<template>
  <v-dialog scrollable v-model="show" width="600">
    <v-card v-if="terms.id">
      <v-card-title> {{ terms.title }} </v-card-title>

      <v-divider></v-divider>

      <v-card-text v-html="terms.content.main" class="pt-4 pb-4"> </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('update:show', false);"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
    name: "TermsModal",
    props: [
        "show",
        "terms"
    ]
}

</script>